import React from 'react';

const WhiteOwlVideoSection = () => {
  return (
    <section className="w-full flex justify-center max-sm:px-4">
      <div className="w-full max-w-5xl">
        <div className="relative rounded-3xl overflow-hidden my-8 bg-white">
          <iframe
            className="w-full aspect-video"
            src="https://www.youtube.com/embed/zKSQeNmXM3M?si=h_NDbfkHPbu4zPri&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3&controls=1"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default WhiteOwlVideoSection;


